import React from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";

const Questions = () => {
  return (
    // This section contains frequently asked questions and their answers.
    <div className="main-section">
      <Container className="position-relative container-sm">
        <Row className="mb-4 justify-content-center mx-auto text-center">
          <Col md={10} lg={7}>
            <div className="section-header my-5">
              <h1>Frequently Asked Questions</h1>
              <p className="text-muted section-subtext">
                Find answers to common questions about our trading platform,
                account types, and services.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="justify-content-center mx-auto text-center">
          <Col md={10} lg={8}>
            <Accordion defaultActiveKey="0" className="faq-accordion">
              <Accordion.Item
                eventKey="0"
                className="mb-3 rounded-4 overflow-hidden"
              >
                <Accordion.Header>
                  How does the trading bot work?
                </Accordion.Header>
                <Accordion.Body>
                  Our advanced trading bot specializes in scalping strategies,
                  executing multiple trades with small profit margins. It
                  operates 24/7, leveraging institutional-grade infrastructure
                  and algorithms to achieve an average monthly return of 37%.
                  All profits are automatically converted to USDT for secure
                  storage.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item
                eventKey="1"
                className="mb-3 rounded-4 overflow-hidden"
              >
                <Accordion.Header>
                  What are the different account types available?
                </Accordion.Header>
                <Accordion.Body>
                  We offer two main account categories: Retail and
                  Institutional. Retail accounts have three tiers (Bronze,
                  Silver, Gold) starting from $5,000, while Institutional
                  accounts require a minimum deposit of $100,000. Each tier
                  comes with specific features and CTE benefits. Visit our
                  Account Types section for detailed information.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item
                eventKey="2"
                className="mb-3 rounded-4 overflow-hidden"
              >
                <Accordion.Header>
                  What is CTE (Company Trading Equity)?
                </Accordion.Header>
                <Accordion.Body>
                  CTE is a unique bonus feature that provides additional
                  benefits based on your account type. Higher-tier accounts
                  receive enhanced CTE benefits, including better trading
                  conditions, priority access to new features, and additional
                  profit-sharing opportunities.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item
                eventKey="3"
                className="mb-3 rounded-4 overflow-hidden"
              >
                <Accordion.Header>
                  What markets can I trade on?
                </Accordion.Header>
                <Accordion.Body>
                  Our platform offers access to both cryptocurrency and
                  commodities markets. We provide institutional OTC pricing
                  access for optimal trade execution. The platform is designed
                  to focus on these two aspects to better serve different
                  investor profiles.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item
                eventKey="4"
                className="mb-3 rounded-4 overflow-hidden"
              >
                <Accordion.Header>
                  How are profits handled after trading sessions?
                </Accordion.Header>
                <Accordion.Body>
                  After each trading session, profits are automatically
                  converted to USDT (stablecoin) for secure storage. This
                  ensures your earnings are protected from market volatility and
                  readily available for future trading or withdrawal.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item
                eventKey="4"
                className="mb-3 rounded-4 overflow-hidden"
              >
                <Accordion.Header>What is scalping?</Accordion.Header>
                <Accordion.Body>
                  Scalping is a trading strategy that involves making multiple
                  trades with small profit margins. It is a high-frequency
                  trading strategy that requires a lot of time and effort to be
                  successful.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Questions;
